import { IResourceComponentsProps } from "@refinedev/core";
import { AntdListInferencer } from "@refinedev/inferencer/antd";
import Cw8List from "components/cw8/Cw8List";

export const SeccionInfografiasList: React.FC<IResourceComponentsProps> = () => {
  const resourceName :string = 'seccionInfografia';
  return (
    <Cw8List
      resourceName = {resourceName}
      showCards ={true}
    ></Cw8List>
  );
};


